import { render, staticRenderFns } from "./SmallInfoModal.vue?vue&type=template&id=7719642a&scoped=true&"
import script from "./SmallInfoModal.vue?vue&type=script&lang=ts&"
export * from "./SmallInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./SmallInfoModal.vue?vue&type=style&index=0&id=7719642a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7719642a",
  null
  
)

export default component.exports